import { Icon as IconifyIcon, InlineIcon, addCollection } from "@iconify/react/offline";
import solar from "../icons/solar.json";
import { ICONS } from "../icons/registry";

// The offline entry point has no API client in it, so nothing is ever fetched
// at render time - the icons come from the bundled subset below.
addCollection(solar);

/**
 * An icon from the Solar set, addressed by role.
 *
 * Renders inline SVG sized in `em`, so the `fontSize` and font-size classes
 * that sized the old icon font still apply unchanged.
 *
 * @param {string} name - a key of ICONS, e.g. "copy"
 * @param {boolean} [inline] - nudge onto the text baseline; use inside a
 *   sentence or a label, not for absolutely positioned icons
 */
const Icon = ({ name, inline = false, ...rest }) => {
  const icon = ICONS[name];

  if (!icon) {
    if (import.meta.env.DEV) {
      console.warn(`Icon "${name}" is not in src/icons/registry.js`);
    }
    return null;
  }

  const Component = inline ? InlineIcon : IconifyIcon;

  // Decorative by default: every icon here sits beside text or in a control
  // that carries its own label. Pass aria-hidden={false} plus a label to
  // override.
  return <Component icon={icon} aria-hidden="true" focusable="false" {...rest} />;
};

export default Icon;
